import React, { useState } from 'react';
import { Box, Typography, TextField, Button, CircularProgress, Link, Alert } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import axios from 'axios';
import AuthLayout, { authInputSx, authSubmitSx } from './AuthLayout';

const API_URL = `${(process.env.REACT_APP_API_BASE || 'http://localhost:5000')}/api/auth`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) return setError('Enter your email address.');
    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      console.error('Forgot password error', err);
      setError(err.response?.data?.message || 'Could not reach the server. Try again in a moment.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Reset your password" subtitle="We'll email you a link to set a new one" busy={submitting}>
      {sent ? (
        <>
          <Alert severity="success" sx={{ borderRadius: 2 }}>
            If an account exists for <strong>{email.trim()}</strong>, a reset link is on its way. It expires in one hour, so check your spam folder if it doesn't arrive.
          </Alert>
          <Button component={RouterLink} to="/login" fullWidth variant="contained" size="large" sx={authSubmitSx}>
            Back to sign in
          </Button>
        </>
      ) : (
        <>
          {error && <Alert severity="error" role="alert" sx={{ borderRadius: 2 }}>{error}</Alert>}
          <form onSubmit={handleSubmit} noValidate style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }} component="label" htmlFor="forgot-email">Email</Typography>
              <TextField
                id="forgot-email"
                fullWidth
                name="email"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                size="small"
                autoComplete="email"
                autoFocus
                disabled={submitting}
                InputProps={{ sx: authInputSx }}
              />
            </Box>
            <Button type="submit" fullWidth variant="contained" size="large" disabled={submitting} sx={authSubmitSx}>
              {submitting ? <CircularProgress size={22} color="inherit" /> : 'Send reset link'}
            </Button>
          </form>
          <Typography variant="body2" sx={{ textAlign: 'center', fontSize: '0.8125rem', mt: 1 }}>
            Remembered it? <Link component={RouterLink} to="/login" underline="hover" sx={{ fontWeight: 600, fontSize: '0.8125rem' }}>Sign in</Link>
          </Typography>
        </>
      )}
    </AuthLayout>
  );
};

export default ForgotPassword;
